<template>
  <ul class="bullet-list list">
    <slot></slot>
  </ul>
</template>

<script>
export default {
  components: {
    // 'render-title':
  },
  props: {
    config: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {}
};
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/standard';

.bullet-list {
  list-style: disc;
}
</style>